// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element/avantage/avantage.scss
 ** module id = 131
 ** module chunks = 0 1
 **/